import { render } from "./Ribbon.vue?vue&type=template&id=1d3ead9c&scoped=true"
import script from "./Ribbon.vue?vue&type=script&lang=js"
export * from "./Ribbon.vue?vue&type=script&lang=js"

import "./Ribbon.vue?vue&type=style&index=0&id=1d3ead9c&scoped=true&lang=css"

import exportComponent from "/home/pewholesaleinnovelapp/wholesale.fresherproduce.ca/releases/81914199/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d3ead9c"]])

export default __exports__